import { Alert } from "antd";

export const McpAdminFeedback = ({ message }: { message: string | null }) =>
  message ? <Alert className="mb-2" type="success" showIcon message={message} /> : null;
